import React from 'react';
import {OPEN_CANVAS_ROOT_ID} from './ViewportStyles';

/**
 * Renders the Open Canvas root wrapper, used by `OpenCanvasBodyElement` as the viewport transformation target.
 *
 * This element will be subject to the CSS transforms during pan & zoom, when these
 * styles update dynamically in `ViewportStyles`.
 *
 * @see ViewportStyles
 */
export const OpenCanvasViewportRoot = (props: React.PropsWithChildren) => {
  return (
    <div
      id={OPEN_CANVAS_ROOT_ID}
      style={OPEN_CANVAS_VIEWPORT_ROOT_STATIC_STYLES}
    >
      {props.children}
    </div>
  );
};

const OPEN_CANVAS_VIEWPORT_ROOT_STATIC_STYLES = {
  width: 0,
  height: 0,
  backgroundColor: 'inherit',
  transformOrigin: '0 0',
};
